module.exports = __webpack_public_path__ + "static/process-5e6b9d6bbeab120c42a4160d780cca36.svg";